/** Rotas públicas onde falha de auth não deve deslogar o usuário. */
export function isPublicAuthPath(pathname = typeof window !== "undefined" ? window.location.pathname : ""): boolean {
  return (
    pathname === "/sistema/biblia" ||
    pathname.startsWith("/sistema/biblia/") ||
    pathname.includes("/cursos") ||
    pathname.includes("/inscricao") ||
    pathname.includes("/inscricoes") ||
    pathname.includes("/eventos") ||
    (!pathname.startsWith("/sistema") && !pathname.startsWith("/login"))
  );
}
